export default __webpack_public_path__ + "static/flirting-be25b57d8538850365f0c3a4bc04d21d.svg";